'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _popupConstants = require('./popupConstants');

var _draggingConstants = require('../../reducers/draggingConstants');

var _selectionConstants = require('../../../common/elements/selectionConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = Immutable.Map();

var addPopup = function addPopup(state, _ref) {
    var popupId = _ref.popupId;
    return state.set(popupId, true);
};
var removePopup = function removePopup(state, _ref2) {
    var popupId = _ref2.popupId;
    return state.delete(popupId);
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        // popup actions
        case _popupConstants.POPUP_OPEN:
            return addPopup(state, action);
        case _popupConstants.POPUP_TOGGLE:
            if (state.get(action.popupId)) return removePopup(state, action);
            return addPopup(state, action);
        case _popupConstants.POPUP_CLOSE:
            if (action.closeAll) return initialState;
            return removePopup(state, action);
        // close popups on these Actions
        case _selectionConstants.ELEMENTS_DESELECT_ALL:
        case _draggingConstants.DRAG_START:
        case '@@router/LOCATION_CHANGE':
            return initialState;
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/popupPanel/popupActiveReducer.js
// module id = 1927
// module chunks = 0